'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.signupOnEnterSaga = signupOnEnterSaga;
exports.cartAbandonerOnEnterSaga = cartAbandonerOnEnterSaga;

var _effects = require('redux-saga/effects');

var _helpers = require('redux/saga/helpers');

var _selectors = require('redux/saga/selectors');

var _requireMembershipStatus = require('routes/helpers/requireMembershipStatus');

var _requireMembershipStatus2 = _interopRequireDefault(_requireMembershipStatus);

var _memberStatus = require('enums/memberStatus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(signupOnEnterSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(cartAbandonerOnEnterSaga);

// redirects to the purchase URL for this item if you are already logged in
function signupOnEnterSaga(client, nextState, replaceState) {
  var loggedIn;
  return _regenerator2.default.wrap(function signupOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          loggedIn = _context.sent;

          if (!loggedIn) {
            _context.next = 6;
            break;
          }

          _context.next = 6;
          return (0, _effects.call)(replaceState, (0, _extends3.default)({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/signup/, '/purchase')
          }));

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function cartAbandonerOnEnterSaga(client, nextState, replaceState) {
  var loggedIn;
  return _regenerator2.default.wrap(function cartAbandonerOnEnterSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          loggedIn = _context2.sent;

          if (loggedIn) {
            _context2.next = 7;
            break;
          }

          _context2.next = 6;
          return (0, _effects.call)(replaceState, '/');

        case 6:
          return _context2.abrupt('return', _context2.sent);

        case 7:
          _context2.next = 9;
          return (0, _effects.call)(_requireMembershipStatus2.default, client, replaceState, [(0, _memberStatus.memberStatus)('UNSUBSCRIBED')]);

        case 9:
          _context2.next = 11;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}